/**
 * Fixed Nav.
 * @module header
 */

import $ from 'jquery';
import throttle from 'lodash/throttle';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'stickyNav';
export const DEFAULTS = {
  stickyElement: '',
  topPosition: 0,
  navLinks: '.js-sticky-nav-link',
  sections: '.js-sticky-nav-section',
};

/**
 * Unfix Site's Header
 * @param  {jQuery} $el - header element
 */
const unStickyNav = ($el) => {
  $el.css({ position: 'static' });
};

/**
 * Make Navigation Sticky
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 */
const setStickyPosition = ($el) => {
  $el.css({ position: 'sticky' });
};

/**
 * Update Active Navigation Link
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
const updateActiveNav = ($el, $window, opts) => {
  const { navLinks, sections } = opts;
  const stickyNavHeight = $el.outerHeight();
  const windowScrollTop = $window.scrollTop();
  const sectionsArray = $(sections).toArray();

  sectionsArray.forEach((section) => {
    const sectionTop = $(section).offset().top - stickyNavHeight - 50;
    const sectionBottom = sectionTop + $(section).outerHeight();

    if (windowScrollTop >= sectionTop && windowScrollTop < sectionBottom) {
      const sectionId = $(section).attr('id');
      $(navLinks).removeClass('active');
      $(`a[href="#${sectionId}"]`).addClass('active');
    }
  });
};

/**
 * Handle Tab Scrolling
 * @param {Event} evt - event object
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
const handleSectionScroll = (evt, $el) => {
  evt.preventDefault();
  const $sectionClicked = $(`${evt.currentTarget.hash}`);
  const stickyNavHeight = $el.outerHeight();
  $('html, body').animate({
    scrollTop: $sectionClicked.offset().top - stickyNavHeight,
  }, 500);
};

/**
 * Update Scroll Position
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
const scrollPositionHandler = ($el, $window, opts) => {
  updateActiveNav($el, $window, opts);
};

/**
 * Set Navigation Offset
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
const setNavOffsetValue = ($el, opts) => {
  const { topPosition } = opts;
  $el.css({ top: `${topPosition}px` });
};

/**
 * Handle Tab Key Events
 * @param {jQuery} $el - header element
 * @param {Event} evt - key event
 */
const tabEventHandler = ($el, evt) => {
  if (['TAB', 'SHIFT_TAB'].includes(Keyboard.parseKey(evt))) {
    unStickyNav($el);
  }
};

/**
 * Set Event Listeners
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 * @param {jQuery} $window - window element
 * @param {jQuery} $body - body element
 * @param {Object} opts - options object
 */
const setEventListeners = ($el, $html, $window, opts) => {
  const { navLinks } = opts;
  $html.on('mousedown.stickyNav', () => setStickyPosition($el));
  $html.on('keyup.stickyNav', (evt) => tabEventHandler($el, evt));
  $window.on('scroll.stickyNav', throttle(() => scrollPositionHandler($el, $window, opts), 100));
  $(navLinks).on('click', (evt) => handleSectionScroll(evt, $el));
};

/**
 * Initialize Fixed Navigation
 * @param {HTMLElement} el - header element
 * @param {Object} options - options object
 */
export default function stickyNav(el, options = {}) {
  const $html = $('html');
  const $window = $(window);
  const $el = DEFAULTS.stickyElement ? $(DEFAULTS.stickyElement) : $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setNavOffsetValue($el, opts);
  setEventListeners($el, $html, $window, opts);
}

// Register jQuery plugin
registerJQueryPlugin(PLUGIN_NAME, stickyNav);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/sticky-nav.js